import ITTIModel from '../../ittijs/ITTIModel';
export default class extends ITTIModel {
	constructor() {
		super('StationAreas');
	}
	getSelectItems(utility, group){
		return this.fetch('getSelectItems', {utility, group});
	}
}